import { FormControl, FormGroup } from '@angular/forms';
import angular from 'angular';
import { Subscription } from 'rxjs';
import { CapabilityIdEnum } from 'src/app/shared/capabilities-and-permissions';

FavoritesController.$inject = ['$scope', 'AlertingFactory', 'TopToolbarFactory', '$translate', 'FavoritesFactory', 'company', 'loggedUser', 'ConfirmationFactory', '$mdDialog', 'sites',
  'siteGroups', 'sitesMap', 'siteGroupsMap', 'DropdownItemsFactory', 'SiteFilterHelperFactory'];
export function FavoritesController($scope, AlertingFactory, TopToolbarFactory, $translate, FavoritesFactory, company, loggedUser, ConfirmationFactory, $mdDialog, sites,
  siteGroups, sitesMap, siteGroupsMap, DropdownItemsFactory, SiteFilterHelperFactory) {

  $scope.company = company;
  $scope.addFavorite = addFavorite;
  $scope.editFavorite = editFavorite;
  $scope.deleteFavoriteOrRemoveAllowedSites = deleteFavoriteOrRemoveAllowedSites;
  $scope.showAll = showAll;
  $scope.hideAll = hideAll;
  $scope.onActiveSwitchChange = onActiveSwitchChange;
  $scope.findTagItems = tag => FavoritesFactory.findTagItems($scope, tag);
  $scope.subscriptions = new Subscription();

  function addFavorite(event) {
    $scope.editorModelAccessor = {};

    $mdDialog.show({
      'controller': 'FavoriteCreationController',
      'template': require('./favorite-creation.dialog.html'),
      'targetEvent': event,
      'clickOutsideToClose': false,
      escapeToClose: false,
      'locals': {
        'favorite': {
          'sites': [],
          'channels': [],
          'teams': [],
          'tags': $scope.allTags.map(tag => ({
            id: tag.id,
            label: tag.label,
            values: [],
            valueList: []
          })),
          'active': 1
        },
        'dropdownItems': $scope.dropdownItems,
        'routingTagExists': $scope.routingTagExists,
        'company': company
      }
    })
      .then(fav => {
        fav.id = $scope.favorites.length > 0 ? Math.max.apply(Math, $scope.favorites.map(o => o.id)) + 1 : 1; // Assign an id to the newly created favorite

        $scope.favorites.push(fav);
        updateFavorites();
      });
  }

  function editFavorite(fav) {
    $scope.editorModelAccessor = {};

    $mdDialog.show({
      'controller': 'FavoriteCreationController',
      'template': require('./favorite-creation.dialog.html'),
      'targetEvent': event,
      'clickOutsideToClose': false,
      'locals': {
        'favorite': fav,
        'dropdownItems': $scope.dropdownItems,
        'routingTagExists': $scope.routingTagExists,
        'company': company
      }
    })
      .then(updatedFav => {
        updateFavorites(updatedFav);
      });
  }

  function updateFavorites(updatedFav) {

    // Replace the original favorite with the updated one
    if (updatedFav) {
      removeMissingTeamsAndTags(updatedFav);
      $scope.favorites.forEach((f, index) => {
        if (f.id === updatedFav.id) {
          $scope.favorites[index] = updatedFav;
        }
      });
    }

    FavoritesFactory.updateFavorites(company.id, $scope.favorites)
      .then(() => {
        processFavorites();
        // Re apply the filters after an update.
        $scope.filtersFormGroup.updateValueAndValidity({ onlySelf: false, emitEvent: true });
        AlertingFactory.success('favorites/update_favorites_success');

      }, AlertingFactory.httpErrorHandler());

    TopToolbarFactory.updateButtonDisable(true, $scope);
  }

  // If a tag value is removed from the company after the favorite was set to use it,
  // it will not be removed by the select-multiple components (nor by the backend)
  // Let's do some clean up here
  function removeMissingTeamsAndTags(fav) {
    fav.teams = fav.teams.filter(team => $scope.allTeams.map(t => t.id).includes(team));
    fav.tags.forEach(tagInFavorite => {
      const tagGroup = $scope.tagsMap.get(tagInFavorite.id);
      tagInFavorite.values = tagInFavorite.values.filter(value => tagGroup.subitems.map(sb => sb.id)
        .includes(value));
    });
  }


  function updateFavoritesOrder() {
    // Transfer custom order of the filteredFavorites to favorites first
    $scope.favorites.sort((x, y) => {
      if ($scope.filteredFavorites.indexOf($scope.filteredFavorites.find(f => f.id === x.id)) < $scope.filteredFavorites.indexOf($scope.filteredFavorites.find(f => f.id === y.id))) {
        return -1;
      }
      if ($scope.filteredFavorites.indexOf($scope.filteredFavorites.find(f => f.id === x.id)) > $scope.filteredFavorites.indexOf($scope.filteredFavorites.find(f => f.id === y.id))) {
        return 1;
      }
      return 0;
    });

    updateFavorites();
  }

  function deleteFavoriteOrRemoveAllowedSites(fav) {
    ConfirmationFactory.materialConfirmDialog('favorites/confirm_favorite_deletion')
      .then(() => {

        let missingSitesIds = fav.sites.filter(siteId => !$scope.allSites.some(site => site.id === siteId));
        if (missingSitesIds.length === 0) {
          // delete favorite only if the user has all the AUTOMATION permission for all the sites of the favorite
          $scope.favorites = $scope.favorites.filter(f => f.id !== fav.id);
        } else {
          // remove favorite from the sites on which the user has AUTOMATION permission
          $scope.favorites.find(f => f.id === fav.id).sites = missingSitesIds;
        }

        FavoritesFactory.updateFavorites(company.id, $scope.favorites)
          .then(() => {
            // filter favorites to update the diplay
            $scope.filteredFavorites = FavoritesFactory.filterFavorites($scope.favorites, { "sites": $scope.allSitesIds });

            AlertingFactory.success('favorites/delete_favorite_success');

          }, AlertingFactory.httpErrorHandler());
      });
  }

  // sortBy needs to be an array of objects
  // arrayToSortContainsObjects needs to be true in case of sorting array of objects 
  function sortFavoritesProperty(favorites, toSort, sortBy, arrayToSortContainsObjects) {
    favorites.forEach(fav => fav[toSort].sort((x, y) => {
      if (sortBy.indexOf(sortBy.find(item => arrayToSortContainsObjects ? item.id === x.id : item.id === x)) < sortBy.indexOf(sortBy.find(item => arrayToSortContainsObjects ? item.id === y.id : item.id === y))) {
        return -1;
      }
      if (sortBy.indexOf(sortBy.find(item => arrayToSortContainsObjects ? item.id === x.id : item.id === x)) > sortBy.indexOf(sortBy.find(item => arrayToSortContainsObjects ? item.id === y.id : item.id === y))) {
        return 1;
      }
      return 0;
    }));
  }

  // Sort favorites properties according to the order of the corresponding array on $scope
  function sortProperties() {
    sortFavoritesProperty($scope.favorites, 'sites', $scope.allSites);
    sortFavoritesProperty($scope.favorites, 'channels', $scope.allChannels.flatMap(type => type.subitems));
    sortFavoritesProperty($scope.favorites, 'teams', $scope.allTeams);
    sortFavoritesProperty($scope.favorites, 'tags', $scope.allTags, true);
    // Sort individual tag values according to server order
    $scope.favorites.forEach(fav => {
      fav.tags.forEach(tag => {
        const tagItems = $scope.tagsMap.get(tag.id).subitems;
        sortFavoritesProperty([tag], 'values', tagItems);
      });
    });
  }

  // Match ids with labels for favorites properties
  function matchIdsWithLabels() {
    const siteMap = $scope.allSites.reduce((sites, site) => {
      sites.set(site.key, site)
      return sites;
    }, new Map());

    $scope.favorites.forEach(fav => {
      if (!fav.temporaryProperties) {
        fav.temporaryProperties = {};
      }
      fav.temporaryProperties.siteListLength = 0;
      fav.sites.forEach(siteId => {
        const site = siteMap.get(`site|${siteId}`);
        if (site) {
          fav.temporaryProperties.siteListLength++;
        }
      });
      (fav.siteGroupIds || []).forEach(siteGroupId => {
        const siteGroup = siteMap.get(`siteGroup|${siteGroupId}`);
        if (siteGroup) {
          fav.temporaryProperties.siteListLength++;
        }
      });

      fav.temporaryProperties.sitesSelectedPreview = _getSitesSelectedPreview(fav);

      const siteListMoreNumber = fav.temporaryProperties.siteListLength - 2;
      fav.temporaryProperties.siteListMore = fav.temporaryProperties.siteListLength > 2 ? `+ ${siteListMoreNumber} ${$translate.instant(siteListMoreNumber === 1 ? 'other' : 'others')}` : '';
      fav.temporaryProperties.text = fav.editorModel?.text || '';
      fav.temporaryProperties.channelList = fav.channels.map(channel => $scope.allChannels.flatMap(type => type.subitems).find(item => item.id === channel)?.label);
      fav.temporaryProperties.teamList = [];
      fav.teams.forEach(team => {
        const matchedTeam = $scope.allTeams.find(t => t.id === team);
        fav.temporaryProperties.teamList.push(matchedTeam ? matchedTeam.label : 'N/A');
      });
      fav.tags.forEach(tag => {
        tag.label = $scope.tagsMap.get(tag.id).label;
        tag.valueList = [];
        tag.values.forEach(value => {
          const matchedTag = $scope.tagsMap.get(tag.id).subitems.find(sb => sb.id === value);
          tag.valueList.push(matchedTag?.label || 'N/A'); // A tag value might have been removed since the favorite was created/updated
        });
        fav[`tag-id-${tag.id}`] = tag.values; // For filtering, will be removed before to be saved.
      });
    });
  }

  // Check if all values are selected for each property
  function checkIfAllValuesAreSelected() {
    $scope.favorites.forEach(favorite => {
      const { siteIds, siteGroupIds } = SiteFilterHelperFactory.extractSitesAndSiteGroups($scope.allSites);
      const allSitesLength = siteIds?.length || 0;
      const allSiteGroupsLength = siteGroupIds?.length || 0;
      const favoriteSitesLength = favorite.sites?.length || 0;
      const favoriteSiteGroupsLength = favorite.siteGroupIds?.length || 0;
      const allAccountsSelected = favoriteSitesLength === allSitesLength && favoriteSiteGroupsLength === allSiteGroupsLength;
      const noAccountsSelected = (!favoriteSitesLength && !favoriteSiteGroupsLength);
      favorite.isForAllSites = allAccountsSelected || noAccountsSelected;
      favorite.isForAllChannels = (favorite.channels.length === $scope.allChannels.flatMap(type => type.subitems).length) || !favorite.channels.length;
      favorite.isForAllTeams = (favorite.teams.length === $scope.allTeams.length) || !favorite.teams.length;

      // Check if all tag values are selected for each tag 
      favorite.tags.forEach(tag => tag.isForAllTagValues = (tag.values.length === $scope.tagsMap.get(tag.id).subitems.length) || !tag.values.length);
    });
  }

  function processFavorites() {
    sortProperties();
    matchIdsWithLabels();
    checkIfAllValuesAreSelected();
    $scope.filteredFavorites = FavoritesFactory.filterFavorites($scope.favorites, { "sites": $scope.allSitesIds });
  }

  // Called when the user clicks on 'expand' in a table cell ('expand' visible only if more than 3 items in cell)
  function showAll(prop, favId, tagId) {
    const key = `showAll${prop}`;

    if (tagId) {
      $scope.favorites.find(fav => fav.id === favId).tags.find(tag => tag.id === tagId)[key] = true;
    } else {
      $scope.favorites.find(fav => fav.id === favId)[key] = true;
    }
  }

  // Called when the user clicks on 'collapse' in a table cell
  function hideAll(prop, favId, tagId) {
    const key = `showAll${prop}`;

    if (tagId) {
      $scope.favorites.find(fav => fav.id === favId).tags.find(tag => tag.id === tagId)[key] = false;
    } else {
      $scope.favorites.find(fav => fav.id === favId)[key] = false;
    }
  }

  function onActiveSwitchChange(fav) {
    updateFavorites(fav);
  }


  init();

  function init() {
    TopToolbarFactory.setButton('favorites/save_order', updateFavoritesOrder, $scope);
    TopToolbarFactory.updateButtonDisable(true, $scope);
    TopToolbarFactory.setSecondaryButton('favorites/create_new_favorite', addFavorite, $scope);

    $scope.filtersFormGroup = new FormGroup({
      active: new FormControl([]),
      sites: new FormControl([]),
      channels: new FormControl([]),
      teams: new FormControl([]),
    });

    $scope.allTags = DropdownItemsFactory.buildTagItems(company.tags_groups.filter(obj => obj.is_routing !== 1));
    $scope.tagsMap = new Map();
    $scope.allTags.forEach(tag => {
      tag.testId = `tags-${tag.label}`;
      tag.subitems = tag.items.flatMap(item => item.subitems);
      $scope.filtersFormGroup.addControl(`tag-id-${tag.id}`, new FormControl([]));
      // Enhance performances, avoid to loop n tags in m favorites after an action / the init.
      $scope.tagsMap.set(tag.id, tag);
    }); // Used for matching the ids with values for favorites tags and for sorting


    $scope.subscriptions.add(
      $scope.filtersFormGroup.valueChanges
        .subscribe(filters => {
          const { siteIds, siteGroupIds } = SiteFilterHelperFactory.extractSitesAndSiteGroupsByKey(filters.sites);
          filters = { ...filters, sites: siteIds, siteGroupIds };
          $scope.filteredFavorites = FavoritesFactory.filterFavorites($scope.favorites, filters);
        })
    );

    $scope.routingTagExists = company.tags_groups.some(obj => obj.is_routing === 1); // Check if the routing_tag for this company exists
    $scope.tableConf = {};

    // Filters
    $scope.sitesKey = `favorites-field-sites-for-company-${company.id}`;
    $scope.channelsKey = `favorites-field-channels-for-company-${company.id}`;
    $scope.teamsKey = `favorites-field-teams-for-company-${company.id}`;
    $scope.tagsKey = `favorites-field-tags-for-company-${company.id}-`;
    $scope.activeKey = `favorites-field-active-for-company-${company.id}`;
    $scope.channelsLabel = $translate.instant('metrics/task_type');
    $scope.teamsLabel = $translate.instant('task/mt/team');
    $scope.activeLabel = $translate.instant('triage_config/columns/active');

    // Header labels
    $scope.headers = {
      order: $translate.instant('list/templates/order'),
      answer: $translate.instant('favorites/answer'),
      account: $translate.instant('metrics/account'),
      channel: $translate.instant('metrics/task_type'),
      team: $translate.instant('task/mt/team'),
      active: $translate.instant('triage_config/columns/active'),
    };

    $scope.favorites = [];
    $scope.dropdownItems = {
      yesOrNo: [
        { id: 0, label: $translate.instant('no') },
        { id: 1, label: $translate.instant('yes') }
      ],
      sites: []
    };
    $scope.showSpinner = true;

    const filteredSites = SiteFilterHelperFactory.filterSitesThatHaveCapability(sites, loggedUser, CapabilityIdEnum.Automation);
    FavoritesFactory.getFavorites(company.id)
      .then(res => {
        $scope.allTeams = res.data.teams;
        $scope.favorites = res.data.favorites;
        const { sites, itemsMap } = SiteFilterHelperFactory.buildAllowedSitesAndSiteGroupsListItems(filteredSites, siteGroups, sitesMap, loggedUser);
        $scope.allSites = sites || [];
        $scope.dropdownItems = {
          ...$scope.dropdownItems,
          sites: $scope.allSites,
          itemsMap
        };
        $scope.allChannels = DropdownItemsFactory.buildChannelItems(sites);

        // Do a check for any newly added tags and update the favorites
        $scope.favorites.forEach(fav => {
          $scope.allTags.forEach(tag => {
            if (!fav.tags.map(t => t.id).includes(tag.id)) {
              fav.tags.push({
                id: tag.id,
                label: tag.label,
                values: []
              });
            }
          });
          // Remove any deleted tags from the favorites
          fav.tags = fav.tags.filter(tag => Array.from($scope.tagsMap.keys()).includes(tag.id));
        });

        // Sort by 'Order' column by default
        $scope.tableConf.sortColumn = 'customOrder';

        $scope.favoritesSortOptions = {
          'axis': 'y',
          'cursor': 'move',
          'handle': '.drag-handle',
          'ui-preserve-size': true,
          'change': () => {
            TopToolbarFactory.updateButtonDisable(false, $scope);
            $scope.tableConf.sortColumn = 'customOrder';
          }
        };

        // Used for table sorting on column header click
        $scope.prevSortOrder = '';
        $scope.colSortOrders = {
          'titleOrder': 'asc',
          'activeOrder': 'asc'
        };

        $scope.showSpinner = false;
        $scope.filteredFavorites = angular.copy($scope.favorites);

        $scope.dropdownItems = {
          ...$scope.dropdownItems,
          channels: $scope.allChannels,
          teams: $scope.allTeams,
          tags: $scope.allTags
        };

        processFavorites();

      }, AlertingFactory.httpErrorHandler());
  }

  /**
   * Show only 2 account + n others (or `+ 1 other`).
   */
  function _getSitesSelectedPreview(favorite) {
    const sites = (favorite.sites || []).map(id => sitesMap.get(id)).filter(i => i && !i.site_group_id);
    const siteGroups = (favorite.siteGroupIds || []).map(id => ({ ...siteGroupsMap.get(id), isGroup: true })).filter(siteGroup => {
      const sitesFromMap = Object.keys(siteGroup.sites || {}).map(key => sitesMap.get(+key)).filter(i => i);
      const sitesFound = SiteFilterHelperFactory.filterSitesThatHaveCapability(sitesFromMap, loggedUser, CapabilityIdEnum.Answer);
      return sitesFound.length
    });
    return siteGroups
      .concat(...sites || [])
      .slice(0, 2)
      .map(item => ({
        ...item,
        typeName: item.type_name,
        icon: `assets/img/site_icon/v2/${item.isGroup ? 'groups/' : ''}${item.type_name}.png`
      }));
  }

  // Disable save order btn if table is not sorted by the first column ('order')
  $scope.$watch('tableConf.sortColumn', () => {
    if ($scope.tableConf.sortColumn !== 'customOrder' && $scope.tableConf.sortColumn !== '-customOrder') {
      TopToolbarFactory.updateButtonDisable(true, $scope);
    }
  });

  $scope.$on('$destroy', function () {
    $scope.subscriptions?.unsubscribe();
  });
}
